import React, { useContext, useEffect, useState } from "react";
import { Alert, Card, Nav, Tab } from "react-bootstrap";
import { ProfileContext } from "../Auth/ProfileProvider";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { FellowshipPrograms } from "../Shared/Models/FellowshipPrograms";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { TrainingProgramTypes } from "../Shared/Models/TrainingProgram";


const TabKeys = {
    Active: 'active' as string,
    Alumni: 'alumni' as string,
    Transfer: 'transfer' as string,
    Reports: 'reports' as string,
    Requirements: 'requirements' as string
} as const;

export default function Dashboard() {
    const { user } = useContext(ProfileContext);
    const [isFellowshipProgram, setIsFellowshipProgram] = React.useState<boolean>(null);
    const navigate = useNavigate();
    const location = useLocation();
    
    const [showApplicationAlert, setShowApplicationAlert] = useState<boolean>(true);

    useEffect(() => {
        const program = user?.trainingPrograms?.find(x => x.trainingProgramId === user.selectedTrainingProgramId);
        const isProgramFellowshipProgram = FellowshipPrograms.includes(program?.trainingProgramTypeId);

        setIsFellowshipProgram(isProgramFellowshipProgram);
        if (isProgramFellowshipProgram) {
            navigate("/Reports");
        }
    }, [user, user?.trainingPrograms, user?.selectedTrainingProgramId])

    const getActiveKeyFromLocation = () => {
        const pathName = location.pathname?.toLowerCase()
        if (pathName.includes(`/${TabKeys.Alumni}`)) return TabKeys.Alumni;
        if (pathName.includes(`/${TabKeys.Transfer}`)) return TabKeys.Transfer;
        if (pathName.includes(`/${TabKeys.Reports}`)) return TabKeys.Reports;
        if (pathName.includes(`/${TabKeys.Requirements}`)) return TabKeys.Requirements;

        return TabKeys.Active;
    }
    
    const showRequirementsTab = () => {
        const program = user?.trainingPrograms?.find(x => x.trainingProgramId === user.selectedTrainingProgramId);
        if (program.trainingProgramTypeId == TrainingProgramTypes.Neurology || program.trainingProgramTypeId == TrainingProgramTypes.Psychiatry || program.trainingProgramTypeId == TrainingProgramTypes.Cap || program.trainingProgramTypeId == TrainingProgramTypes.ChN || program.trainingProgramTypeId == TrainingProgramTypes.ChildNeurologyAndNeurodevelopmentalDisabilities || program.trainingProgramTypeId == TrainingProgramTypes.TripleBoard || program.trainingProgramTypeId == TrainingProgramTypes.PsychiatryAndInternalMedicine || program.trainingProgramTypeId == TrainingProgramTypes.PsychiatryAndInternalMedicine || program.trainingProgramTypeId == TrainingProgramTypes.PsychiatryAndFamilyMedicine || program.trainingProgramTypeId == TrainingProgramTypes.PsychiatryNeurology || program.trainingProgramTypeId == TrainingProgramTypes.PostPediatricPortal) {
            return true;
        }
        return false;
    }

    if (!user) return <AbpnSpinner />

    return (
        <Card className="border-pc-secondary-grey">
            <Card.Body>
                {showApplicationAlert &&
                    <Alert variant={"secondary"} onClose={() => setShowApplicationAlert(false)} dismissible>
                        Welcome to a new and improved version of preCERT!<br /><br />
                        The new ABPN preCERT system is easier to use and will require less data entry, since it shifts from programs entering all the number of months of rotations for each resident to an attestation model for completed rotations. A new feature added to preCERT is a mechanism for programs to easily upload the verification letters received at the time of transfer for any residents that complete training outside of the residency.  In the past, these letters were emailed/faxed to ABPN regarding pgy-1 training credit. <br /><br />
                        As of July 1, 2023, all CSEs conducted must return to face-to-face as ABPN will no longer be accepting virtual CSEs.<br /><br />
                        Final attestation of completion of all training requirements will continue to be done by the program director.<br /><br />
                        Please visit ABPN.com for <a className="link-primary" target="_blank" rel="noreferrer" href="https://www.abpn.com/quick-links/">application periods and exam administration dates</a>, <a className="link-primary" target="_blank" rel="noreferrer" href="https://www.abpn.com/wp-content/uploads/2015/05/ABPN_Name_DOB_SSN_Change_Instructions.pdf">name/birthdate/SSN4 change information</a> and the <a className="link-primary" target="_blank" rel="noreferrer" href="https://www.abpn.com/access-residency-info/">latest ABPN newsletter</a>. As a reminder, the ABPN application periods and examinations take place at relatively the same time each year.<br /><br />
                        If you have any questions, please contact us at <a  href={"mailTo:credentials@abpn.com?subject=ABPN Account Help"}>credentials@abpn.com</a>.
                    </Alert>
                }
                <Tab.Container activeKey={getActiveKeyFromLocation()}>
                    <Nav variant="tabs">
                        <Nav.Item>
                            <Nav.Link className={isFellowshipProgram ? 'd-none' : ''} eventKey={TabKeys.Active} as={Link} to={`/`}>Active Roster</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link className={isFellowshipProgram ? 'd-none' : ''} eventKey={TabKeys.Alumni} as={Link} to={`/Alumni`}>Alumni Roster</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link className={isFellowshipProgram ? 'd-none' : ''} eventKey={TabKeys.Transfer} as={Link} to={`/Transfer`}>Transfer</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey={TabKeys.Reports} as={Link} to={`/Reports`}>Reports</Nav.Link>
                        </Nav.Item>
                        {showRequirementsTab() && 
                            <Nav.Item>
                                <Nav.Link eventKey={TabKeys.Requirements} as={Link} to={`/Requirements`}>Requirements</Nav.Link>
                            </Nav.Item>
                        }
                    </Nav>
                </Tab.Container>
                <Tab.Content className="mt-2">
                    <Outlet/>
                </Tab.Content>
            </Card.Body>
        </Card >
    );
}
